import React from 'react';

declare const window: any;

const NewsroomItem: React.FunctionComponent<any> = ({ data }) => {
  const goToArticle = () => {
    window.open(data.article_link, '_blank');
  }

  return (
    <div onClick={goToArticle} className="flex items-center border-4 border-black mb-4 p-2.5 cursor-pointer">
      <div className="flex-1 pr-6 font-bold">
        <span className={`text-xs block ${!data.isCGI ? 'text-main-purple' : 'text-main-green'}`}>{data.type_of_article}</span>
        <span className="text-lg block">{data.article_title}</span>
      </div>
      <button className="text-4xl mr-3">&#9656;</button>
    </div>
  )
}

export default NewsroomItem;